/* ===== game/perf.ts — 성능: 동적 해상도 · 효율 강화 모드(설정 eco) ===== */
import { mixin } from '../../engine/core/mixin.js';
import { DynRes } from '../../engine/platform/dynres.js';
import { tr } from '../lang.js';
import { Game, QUALITY } from '../game.js';
/* ★ 동적 해상도는 평소에는 **기기 화소 1 배 밑으로 안 내린다** — 칸 그림이 1 배 픽셀 그림이라 2 배 → 1 배는 거의 같아 보이고(글 · 선만 덜 날카롭다),
   1 배 밑부터 흐려진다. 효율 강화 모드만 0.5 배까지 내리고, 30fps 로 묶고, 화질을 절약(입자 · 창 움직임)으로 둔다. 사연: docs/code-history.md#h247 */

export const ECO = { fps: 30, min: 0.5 };

export const PerfPart: Bag = {
  /** 효율 강화 모드인가 */
  eco() { return !!(this.settings && this.settings.eco); },
  /** 루프의 프레임 사이 최소 간격(초) */
  frameCap() { return this.eco() && this.state === 'play' ? 1 / ECO.fps : 0; },
  /** 지금 화질의 화소 밀도 상한과 동적 해상도가 곱할 배율 → 실제 밀도 */
  renderDpr() {
    const Q = QUALITY[this.quality()], dev = (typeof devicePixelRatio === 'number' && devicePixelRatio) || 1;
    let top = Math.min(Q.dpr, dev);
    if (Q.px) top = Math.max(0.5, Math.min(top, Math.sqrt(Q.px / Math.max(1, innerWidth * innerHeight))));
    const eco = this.eco(), max = eco ? Math.min(1, top) : top, min = eco ? Math.min(max, ECO.min) : Math.min(max, 1);
    const budget = eco ? 1 / ECO.fps : 1 / 60;
    if (!this.drs) this.drs = new DynRes({ min, max, budget });
    else if (this._drsKey !== min + '|' + max + '|' + budget) this.drs.set({ min, max, budget });
    this._drsKey = min + '|' + max + '|' + budget;
    if (this.settings && this.settings.drs === 0) return max;   // 동적 해상도를 끈 설정(디버그 · 비교용)
    return this.drs.scale;
  },
  /** 프레임마다 — 늦으면 화소를 줄이고 여유가 생기면 되돌린다(engine platform/dynres) */
  perfTick(rawDt: number, jsMs: number) {
    if (!this.drs || this.state !== 'play' || this.paused) return;
    this.slowHint(rawDt);
    if (this.settings && this.settings.drs === 0) return;
    if (this.drs.frame(rawDt, jsMs, performance.now() / 1000)) this.resize();
  },
  /** 20초 넘게 초당 22장이 안 나오면 효율 강화 모드를 한 번 권한다(다시는 안 묻는다 — 설정 ecoHint) */
  slowHint(rawDt: number) {
    const s = this.settings;
    if (!s || s.eco || s.ecoHint || !(rawDt > 0) || rawDt > 0.25) return;
    const h = this._slow || (this._slow = { t: 0, n: 0 });
    h.t += rawDt; h.n++;
    if (h.t < 20) return;
    if (h.n / h.t < 22) { s.ecoHint = 1; this.saveSettings(); this.toast(tr('화면이 느리다 — 설정에서 효율 강화 모드를 켜면 가벼워진다'), 'info'); }
    h.t = h.n = 0;
  },
  /** 땅의 공기색 — 효율 모드에서는 소프트 라이트(화면 한 장 5ms)를 빼고 같은 세기의 덮기 한 겹만 */
  airCheap() { return this.eco(); },
};
mixin(Game.prototype, PerfPart, true);
